import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const GET_ORGANIZATION_MEMBERS_AND_INVITATIONS = gql(`
  query GET_ORGANIZATION_MEMBERS_AND_INVITATIONS($organizationSlug: String!) {
    organization(organizationSlug: $organizationSlug) {
      ... on Organization {
        __typename
        id
        members {
          __typename
          id
          role
          user {
            __typename
            fullName
            email
            id
          }
        }
        pendingInvitations {
          __typename
          id
          invitedAt
          email
          role
        }
      }
    }
  }
`);

type Props = {
  organizationSlug?: string;
};

export const useGetOrganizationUsersAndInvitations = ({
  organizationSlug
}: Props) => {
  const result = useQuery(GET_ORGANIZATION_MEMBERS_AND_INVITATIONS, {
    skip: !organizationSlug,
    variables: { organizationSlug: organizationSlug || "" }
  });
  return result;
};
